import { pushLog } from 'src/utils/pushLog';
import Vue from 'vue';
import { WEB_HOOK } from 'src/utils/config';

const IS_PROD = process.env.ENV === 'production';
// const IS_CHAT = process.env.ENV === 'chat';

// TODO：过滤一些无用的上报
Vue.config.errorHandler = function (err, vm, info) {
  pushLog({
    key: '[VueRuntimeError]',
    url: vm.$route.fullPath,
    component_desc: vm.$vnode.tag,
    errObj: JSON.stringify(err),
    errInfo: JSON.stringify(info),
    user: JSON.stringify({
      phone: vm.userInfo?.phone,
    })
  });
}

window.onerror = function (message, source, lineno, colno, error) {
  if (message.includes('Script error')) return;
  // console.error(message, source, lineno, colno, error);
  pushLog({
    key: '[WindowGlobalError]',
    url: window.location.href,
    message,
    source: JSON.stringify(source),
    lineno,
    colno,
    error: JSON.stringify(error)
  });
}
